import React from 'react'
import slider01 from '../images/slider-img-01.png'
import slider02 from '../images/img-box-01.png'
import slider03 from '../images/img-box-02.png'
import slider04 from '../images/img-box-03.png'
import PrimaryBtn from './btn/PrimaryBtn'
export default function Blog() {
  return (
    <div>
      <section className="section03">
          <div className="container-fluid">
              <div className="col-md-11 mx-auto">
                <div className="row align-items-end mb-5">
                  <div className="col-md-7">
                    <h2 className="heading mb-0"><span>Shipping Insights:</span> Tips and Tricks for a Smooth Transition</h2>
                  </div>
                  <div className="col-md-5 text-right">
                    <PrimaryBtn text="All Insights"/>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <img src={slider01} className="img-fluid mb-4 border-radius" alt="" />
                    <p className="f-12">November 20, 2023</p>
                    <p className="fw-500 f-24">Choosing the Right Shipping Aggregator: What to Look For</p>
                    <p className="f-16">Lorem morbi et amet suscipit. At sed proin quis risus urna a. Magna in odio in urna amet ultrices fermentum. Mauris in pretium eget donec erat ipsum a leo. Maecenas elementum consectetur ac blandit tortor.</p>
                  </div>
                  <div className="col-md-6 pl-5">
                    <div className="row border-bottom pb-4">
                      <div className="col-md-5">
                        <img src={slider02} className="img-fluid mb-3" alt="" />
                      </div>
                      <div className="col-md-7 pl-0">
                        <p className="f-12">November 20, 2023</p>
                        <p className="fw-500 f-24">Planning Your Move: A Step-by-Step Guide to Success</p>
                      </div>
                    </div>
                    <div className="row border-bottom py-4">
                      <div className="col-md-5">
                        <img src={slider03} className="img-fluid mb-3" alt="" />
                      </div>
                      <div className="col-md-7 pl-0">
                        <p className="f-12">November 20, 2023</p>
                        <p className="fw-500 f-24">The Art of Efficient Packing: Tips to Make Your Move Easier</p>
                      </div>
                    </div>
                    <div className="row  pt-4">
                      <div className="col-md-5">
                        <img src={slider04} className="img-fluid mb-3" alt="" />
                      </div>
                      <div className="col-md-7 pl-0">
                        <p className="f-12">November 20, 2023</p>
                        <p className="fw-500 f-24">Dealing with Kids and Pets: Making Your Move Family-Friendly</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </section>
    </div>
  )
}
